var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid mt-4" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex justify-content-around align-items-center mt-5" },
      [
        _c(
          "div",
          {
            staticClass: "form-style-box",
            class: [_vm.type === "custom" ? "selected" : ""],
            on: {
              click: function($event) {
                _vm.type = "custom"
              }
            }
          },
          [
            _c("div", { staticClass: "form-style-name mb-1" }, [
              _vm._v("\n        Custom form\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-style-subheading mt-3" }, [
              _vm._v(
                "\n        Choose this option if you want to create your own form. We will provide you with the necessary information how to submit it.\n      "
              )
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-style-box",
            class: [_vm.type === "editing" ? "selected" : ""],
            on: {
              click: function($event) {
                _vm.type = "editing"
              }
            }
          },
          [
            _c("div", { staticClass: "form-style-name mb-1" }, [
              _vm._v("\n        Simple button\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-style-subheading mt-3 mb-3" }, [
              _vm._v(
                "\n        Choose this option if you just want a simple button that will open a modal or pop-up form.\n      "
              )
            ]),
            _vm._v(" "),
            _vm._m(2)
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-style-box",
            class: [_vm.type === "iframe" ? "selected" : ""],
            on: {
              click: function($event) {
                _vm.type = "iframe"
              }
            }
          },
          [
            _c("div", { staticClass: "form-style-name mb-1" }, [
              _vm._v("\n        Iframe form\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-style-subheading mt-3" }, [
              _vm._v(
                "\n        Choose this option if you want to embed a form on your website.\n      "
              )
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-100 mt-5 mr-3 text-center" }, [
      _c("span", { staticClass: "text-danger" }, [
        _vm._v("Web key: " + _vm._s(_vm.company.web_key))
      ])
    ]),
    _vm._v(" "),
    _vm.type.length
      ? _c(
          "div",
          { staticClass: "d-flex flex-column align-items-center mt-5" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-primary text-uppercase proceed-button",
                on: { click: _vm.proceed }
              },
              [_vm._v("\n      proceed to web quote settings\n    ")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-column justify-content-center mb-4" },
      [
        _c("span", { staticClass: "welcome mt-5" }, [
          _vm._v("\n      welcome to your custom form settings\n    ")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "welcome-subheading mt-3" }, [
          _vm._v(
            "\n      You can create a custom form and copy the code into your website. New leads will come directly into mod24 dispatch app.\n      "
          ),
          _c("br"),
          _vm._v("\n      Choose one of the options below.\n    ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-style-list mt-2" }, [
      _c("ul", [_c("li", [_vm._v("\n            Your own style\n          ")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-style-list mt-2" }, [
      _c("ul", [
        _c("li", [
          _vm._v("\n            Customisable button style\n          ")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n            Simple to add to your HTML app\n          ")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n            Predefined form pop-up or modal\n          ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-style-list mt-2" }, [
      _c("ul", [
        _c("li", [_vm._v("\n            Simple\n          ")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n            Connected to your company on mod24\n          ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-733ea8aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-733ea8aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesWebQuoteSelect.vue
// module id = null
// module chunks = 